// src/components/About.tsx

import { motion } from "framer-motion";
import { AiOutlineArrowRight } from "react-icons/ai";

import storyImage from "../assets/women.png";
import missionImage from "../assets/justmachine.png";
import visionImage from "../assets/Manusingmachine.png";

import "../styles/about.css";

const About = () => {
  return (
    <section
      id="about"
      className="about"
    >

      {/* =========================
          HEADER
      ========================= */}

      <div className="about-header">

        <span>
          ABOUT US
        </span>

        <h2>
          From Leaky Shakers
          <br />
          To Instant Fuel
        </h2>

        <p>
          Dagda helps busy gym members stay consistent
          by putting fresh workout nutrition inside the gym,
          not in their backpacks.
        </p>

      </div>


      {/* =====================================================
          STORY SECTION
      ===================================================== */}

      <div className="about-row">

        {/* IMAGE */}

        <motion.div
          className="about-image-wrapper"
          initial={{
            opacity: 0,
            x: -40
          }}
          whileInView={{
            opacity: 1,
            x: 0
          }}
          transition={{
            duration: 0.7
          }}
          viewport={{
            once: true
          }}
        >

          <div className="person-wrapper">

            <div className="orange-shape"></div>

            <div className="small-circle one"></div>

            <div className="small-circle two"></div>

            <img
              src={storyImage}
              alt="Dagda Story"
              className="person-image"
            />

          </div>

        </motion.div>


        {/* TEXT */}

        <motion.div
          className="about-content"
          initial={{
            opacity: 0,
            x: 40
          }}
          whileInView={{
            opacity: 1,
            x: 0
          }}
          transition={{
            duration: 0.7
          }}
          viewport={{
            once: true
          }}
        >

          <span className="mini-tag">
            OUR STORY
          </span>

          <h3>
            Built Around
            Real Gym Life
          </h3>

          <p>
            We’re a small team in Ireland
            who live the same routine as you
            office, lectures, commute and then
            straight to the gym.
          </p>

          <p>
            We’ve experienced leaking shakers,
            forgotten protein tubs and the
            inconvenience of carrying supplements
            everywhere.
          </p>

          <p>
            So we built Dagda
            smart vending machines that deliver
            fresh protein and performance drinks
            instantly where people train.
          </p>

        </motion.div>

      </div>


      {/* =====================================================
          MISSION SECTION
      ===================================================== */}

      <section className="about-feature mission-feature">

        {/* HUGE BACKGROUND TEXT */}

        <motion.div
          className="feature-background-word"
          initial={{
            opacity: 0,
            x: -100
          }}
          whileInView={{
            opacity: 1,
            x: 0
          }}
          transition={{
            duration: 1
          }}
          viewport={{
            once: true
          }}
        >
          MISSION
        </motion.div>


        {/* TOP NUMBER */}

        <motion.div
          className="feature-number"
          initial={{
            opacity: 0,
            y: -20
          }}
          whileInView={{
            opacity: 1,
            y: 0
          }}
          transition={{
            duration: 0.6
          }}
          viewport={{
            once: true
          }}
        >
          <span>02</span>

          <div></div>

          <p>OUR MISSION</p>
        </motion.div>


        <div className="feature-content">


          {/* IMAGE */}

          <motion.div
            className="feature-image mission-image"
            initial={{
              opacity: 0,
              scale: 0.85,
              x: 80
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0
            }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1]
            }}
            viewport={{
              once: true
            }}
          >

            <div className="feature-image-glow"></div>

            <div className="feature-image-circle"></div>

            <motion.img
              src={missionImage}
              alt="Dagda Mission"
              whileInView={{
                scale: [1, 1.04, 1]
              }}
              transition={{
                duration: 5,
                ease: "easeInOut"
              }}
              viewport={{
                once: false
              }}
            />

          </motion.div>


          {/* TEXT */}

          <motion.div
            className="feature-text"
            initial={{
              opacity: 0,
              x: -60
            }}
            whileInView={{
              opacity: 1,
              x: 0
            }}
            transition={{
              duration: 0.9,
              delay: 0.15
            }}
            viewport={{
              once: true
            }}
          >

            <span className="feature-small-title">
              OUR MISSION
            </span>

            <h3>
              Protein,
              <br />
              Ready When
              <br />
              <span>You Are</span>
            </h3>

            <div className="feature-line"></div>

            <p>
              Our mission is to deliver
              fresh, high-quality protein
              and performance drinks in
              under two minutes through
              intelligent vending technology.
            </p>

            <p>
              We help gym-goers stay consistent
              without carrying tubs, shakers
              or supplements from home.
            </p>

          </motion.div>

        </div>


        {/* BOTTOM LINE */}

        <motion.div
          className="feature-bottom-line"
          initial={{
            scaleX: 0
          }}
          whileInView={{
            scaleX: 1
          }}
          transition={{
            duration: 1.2
          }}
          viewport={{
            once: true
          }}
        />

      </section>


      {/* =====================================================
          VISION SECTION
      ===================================================== */}

      <section className="about-feature vision-feature">

        {/* HUGE BACKGROUND TEXT */}

        <motion.div
          className="feature-background-word vision-word"
          initial={{
            opacity: 0,
            x: 100
          }}
          whileInView={{
            opacity: 1,
            x: 0
          }}
          transition={{
            duration: 1
          }}
          viewport={{
            once: true
          }}
        >
          VISION
        </motion.div>


        {/* TOP NUMBER */}

        <motion.div
          className="feature-number vision-number"
          initial={{
            opacity: 0,
            y: -20
          }}
          whileInView={{
            opacity: 1,
            y: 0
          }}
          transition={{
            duration: 0.6
          }}
          viewport={{
            once: true
          }}
        >

          <span>03</span>

          <div></div>

          <p>OUR VISION</p>

        </motion.div>


        <div className="feature-content vision-content">


          {/* TEXT */}

          <motion.div
            className="feature-text vision-text"
            initial={{
              opacity: 0,
              x: -60
            }}
            whileInView={{
              opacity: 1,
              x: 0
            }}
            transition={{
              duration: 0.9
            }}
            viewport={{
              once: true
            }}
          >

            <span className="feature-small-title">
              OUR VISION
            </span>

            <h3>
              Smart Nutrition
              <br />
              <span>Everywhere</span>
            </h3>

            <div className="feature-line"></div>


            {/* VISION POINTS */}

            <div className="vision-points">

              <motion.div
                className="vision-point"
                initial={{
                  opacity: 0,
                  x: -30
                }}
                whileInView={{
                  opacity: 1,
                  x: 0
                }}
                transition={{
                  delay: 0.2,
                  duration: 0.6
                }}
                viewport={{
                  once: true
                }}
              >

                <div className="vision-arrow">

                  <AiOutlineArrowRight size={18} />

                </div>

                <p>
                  To make essential workout nutrition
                  instantly available to every gym-goer.
                </p>

              </motion.div>


              <motion.div
                className="vision-point"
                initial={{
                  opacity: 0,
                  x: -30
                }}
                whileInView={{
                  opacity: 1,
                  x: 0
                }}
                transition={{
                  delay: 0.35,
                  duration: 0.6
                }}
                viewport={{
                  once: true
                }}
              >

                <div className="vision-arrow">

                  <AiOutlineArrowRight size={18} />

                </div>

                <p>
                  Build the future of smart recovery
                  experiences through automation
                  and convenience.
                </p>

              </motion.div>

            </div>

          </motion.div>


          {/* IMAGE */}

          <motion.div
            className="feature-image vision-image"
            initial={{
              opacity: 0,
              scale: 0.85,
              x: 80
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0
            }}
            transition={{
              duration: 1,
              ease: [0.16, 1, 0.3, 1]
            }}
            viewport={{
              once: true
            }}
          >

            <div className="feature-image-glow"></div>

            <div className="feature-image-circle"></div>

            <motion.img
              src={visionImage}
              alt="Dagda Vision"
              whileInView={{
                scale: [1, 1.04, 1]
              }}
              transition={{
                duration: 5,
                ease: "easeInOut"
              }}
              viewport={{
                once: false
              }}
            />

          </motion.div>

        </div>


        {/* BOTTOM LINE */}

        <motion.div
          className="feature-bottom-line"
          initial={{
            scaleX: 0
          }}
          whileInView={{
            scaleX: 1
          }}
          transition={{
            duration: 1.2
          }}
          viewport={{
            once: true
          }}
        />

      </section>

    </section>
  );
};

export default About;